import uweb from 'vue-uweb';
import Vue from 'vue';

Vue.use(uweb, {
    siteId: '1279615077',
    debug: process.env.NODE_ENV !== 'production'
});

const UMWebPlugin = {
    install: function (Vue) {
        Vue.mixin({
            methods: {
                async initUM() {
                    try {
                        await this.$uweb.ready();
                    } catch (e) {
                        // error handling here
                    }
                },
                async $trackPageview(...args) {
                    await this.initUM();
                    this.$uweb.trackPageview(...args);
                },
                async $trackEvent(...args) {
                    await this.initUM();
                    this.$uweb.trackEvent(...args);
                },
                async $setCustomVar(...args) {
                    await this.initUM();
                    this.$uweb.setCustomVar(...args);
                },
                async $setAccount(...args) {
                    await this.initUM();
                    this.$uweb.setAccount(...args);
                },
                async $setAutoPageview(...args) {
                    await this.initUM();
                    this.$uweb.setAutoPageview(...args);
                },
                async $deleteCustomVar(...args) {
                    await this.initUM();
                    this.$uweb.deleteCustomVar(...args);
                }
            }
        });
    }
};

Vue.use(UMWebPlugin);
